// extracted by mini-css-extract-plugin
export default {"metricCard":"metric-card_metricCard__noAnc"};